import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

import 'rxjs/Rx'; // importing RxJs operators like map
import { HospitalModel } from '../model/hospital.model';
import { TrainerHospitalModel } from '../model/trainer_hospital.model';
import { API_URLS } from '../utils/api_url.util';
import { API_UTILS } from '../utils/api_utils.util';
import { FacultyMedicalProcedureHospitalModel } from '../model/faculty_medical_procedure_hospital.model';
import { catchError } from 'rxjs/operators';
import { UserModel } from '../model/user.model';

/*
  Generated class for the UserFaculties provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class HospitalService {
	items: HospitalModel[];
	mHospital!: HospitalModel;

	constructor(private http: HttpClient) {
		this.items = null;
	}

	getItems(): Observable<Array<HospitalModel>> {
		let items$ = this.http.get<Array<HospitalModel>>(API_URLS.API_GET_HOSPITALS).pipe(catchError(handleError));
		return items$;
	}

	getHospital(id: string): Observable<HospitalModel> {
		let items$ = this.http.get<HospitalModel>(API_URLS.API_GET_HOSPITAL + `/${id}`).pipe(catchError(handleError));
		return items$;
	}

	getByFacultyMedicalProcedure(id: string): Observable<Array<FacultyMedicalProcedureHospitalModel>> {
		let items$ = this.http
			.get<Array<FacultyMedicalProcedureHospitalModel>>(API_URLS.API_GET_BY_FACULTY_MEDICAL_PROCEDURE + `/${id}`)
			.pipe(catchError(handleError));
		return items$;
	}

	getTrainerHospitals(id: string): Observable<Array<TrainerHospitalModel>> {
		let items$ = this.http
			.get<Array<TrainerHospitalModel>>(API_URLS.API_GET_TRAINER_HOSPITALS + `/${id}`)
			.pipe(catchError(handleError));
		return items$;
	}

	getHospitalTrainers(id: string): Observable<Array<UserModel>> {
		let items$ = this.http
			.get<Array<UserModel>>(API_URLS.API_GET_HOSPITAL_TRAINERS + `/${id}`)
			.pipe(catchError(handleError));
		return items$;
	}

	addTrainerHospital(item: TrainerHospitalModel): Observable<TrainerHospitalModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };

		let items$ = this.http
			.post<TrainerHospitalModel>(API_URLS.API_POST_ADD_TRAINER_HOSPITAL, body, options)
			.pipe(catchError(handleError));
		return items$;
	}

	removeSupervisorHospital(item: TrainerHospitalModel): Observable<TrainerHospitalModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };
		let id = item.Id;

		let items$ = this.http
			.get<TrainerHospitalModel>(API_URLS.API_GET_REMOVE_TRAINER_HOSPITAL + `/${id}`)
			.pipe(catchError(handleError));
		return items$;
	}

	addItem(item: HospitalModel): Observable<HospitalModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };

		let items$ = this.http
			.post<HospitalModel>(API_URLS.API_ADD_HOSPITAL, body, options)
			.pipe(catchError(handleError));
		return items$;
	}

	editItem(item: HospitalModel): Observable<HospitalModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };
		let id = item.Id;

		let items$ = this.http
			.post<HospitalModel>(API_URLS.API_EDIT_HOSPITAL, body, options)
			.pipe(catchError(handleError));
		return items$;
	}

	removeItem(item: HospitalModel): Observable<HospitalModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };
		let id = item.Id;

		let items$ = this.http
			.get<HospitalModel>(API_URLS.API_REMOVE_HOSPITAL + `/${id}`)
			.pipe(catchError(handleError));
		return items$;
	}
}

// this could also be a private method of the component class
function handleError(error: HttpErrorResponse) {
	// log error
	// could be something more sofisticated
	console.error(error);

	return observableThrowError(error.error);
}
